function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { assert } from '../../client/utils';
var _applicationId = /*#__PURE__*/new WeakMap();
var _applicationName = /*#__PURE__*/new WeakMap();
var _slotName = /*#__PURE__*/new WeakMap();
var _configRoot = /*#__PURE__*/new WeakMap();
export var SpaSlot = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {{slotName: string, appName: string, appId: string}} slotName
   * @param {IlcConfigRoot} rootConfig
   */
  function SpaSlot(rawSlot, configRoot) {
    _classCallCheck(this, SpaSlot);
    _classPrivateFieldInitSpec(this, _applicationId, void 0);
    _classPrivateFieldInitSpec(this, _applicationName, void 0);
    _classPrivateFieldInitSpec(this, _slotName, void 0);
    /**
     * @property {IlcConfigRoot}
     */
    _classPrivateFieldInitSpec(this, _configRoot, void 0);
    var applicationId = rawSlot.applicationId,
      applicationName = rawSlot.applicationName,
      slotName = rawSlot.slotName;
    assert(applicationId !== 'string', "SpaSlot instance can not be initiated without applicationId where rawSlot = ".concat(JSON.stringify(rawSlot)));
    assert(applicationName !== 'string', "SpaSlot instance can not be initiated without applicationName where rawSlot = ".concat(JSON.stringify(rawSlot)));
    assert(slotName !== 'string', "SpaSlot instance can not be initiated without slotName where rawSlot = ".concat(JSON.stringify(rawSlot)));
    _classPrivateFieldSet(_applicationId, this, applicationId);
    _classPrivateFieldSet(_applicationName, this, applicationName);
    _classPrivateFieldSet(_slotName, this, slotName);
    _classPrivateFieldSet(_configRoot, this, configRoot);
  }

  /**
   * @method
   * @return {string} ApplicationName
   */
  return _createClass(SpaSlot, [{
    key: "getApplicationName",
    value: function getApplicationName() {
      return _classPrivateFieldGet(_applicationName, this);
    }

    /**
     * @method
     * @return {string} ApplicationId
     */
  }, {
    key: "getApplicationId",
    value: function getApplicationId() {
      return _classPrivateFieldGet(_applicationId, this);
    }

    /**
     * @method
     * @return {string} getSlotName
     */
  }, {
    key: "getSlotName",
    value: function getSlotName() {
      return _classPrivateFieldGet(_slotName, this);
    }

    /**
     * @method
     * @description Method return is slot is associated with valid application
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function isValid() {
      return !!_classPrivateFieldGet(_configRoot, this).getConfigForAppByName(_classPrivateFieldGet(_applicationName, this));
    }

    /**
     * @method
     * @return {{slotName: string, appName: string, appId: string}}
     */
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        appId: this.getApplicationId(),
        appName: this.getApplicationName(),
        slotName: this.getSlotName()
      };
    }
  }]);
}();